<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
	class="feather feather-music"
>
	<path d="M9 18V5l12-2v13" />
	<circle cx="6" cy="18" r="3" />
	<circle cx="18" cy="16" r="3" />
</svg>
